import { ReactComponent as ControlArrow } from '@img/icons/cta-chevron.svg';
import * as React from 'react';
import S from './CarouselButtons.styles';
const CarouselButtons = ({ prevDisabled, nextDisabled, prevClicked, nextClicked, children, }) => {
    return (React.createElement(S.Container, { "data-inactive": prevDisabled && nextDisabled },
        React.createElement(S.CarouselButtonPrev, { disabled: prevDisabled, onClick: () => prevClicked() },
            React.createElement(ControlArrow, null)),
        children,
        React.createElement(S.CarouselButtonNext, { disabled: nextDisabled, onClick: () => nextClicked() },
            React.createElement(ControlArrow, null))));
};
export default CarouselButtons;
